// A style profile's editing guide, wherever it is read: the project drawer, the admin's client page,
// the Style Profile page itself.
//
// A download when the file was uploaded: video.editing_guide_file_id, the same serve link the presets
// use (app/style_profile_files.py lets the client's assigned editor read it). A file name with no
// upload behind it says so: until 2026-09-23 the setup wizard kept only the chosen file's NAME, so
// the file never reached us (16 of 23 named guides in production that day). Anything else is shown
// as the client wrote it.

const GUIDE_FILE_NAME = /\.(pdf|docx?|txt|rtf|pages|odt)$/i;

export function isGuideFileName(name) {
  return GUIDE_FILE_NAME.test((name || '').trim());
}

export function EditingGuideValue({ video }) {
  const name = (video?.editing_guide || '').trim();
  if (!name) return null;
  if (video.editing_guide_file_id) {
    return (
      <a href={`${process.env.REACT_APP_BACKEND_URL}/api/storage/serve/${video.editing_guide_file_id}`} data-testid="editing-guide-link"
        className="tap-auto text-oxidized-teal hover:text-oxidized-teal/80 underline underline-offset-2 break-all">{name}</a>
    );
  }
  if (isGuideFileName(name)) {
    return (
      <span data-testid="editing-guide-missing" className="break-all">
        {name} <span className="text-slate-500">(file not uploaded)</span>
      </span>
    );
  }
  return <span className="whitespace-pre-wrap break-words">{name}</span>;
}
